import {useMemo} from 'react'

import {useGetUserStorage} from '../../shared/hooks/userStorage/getValue'
import {RawUserSignalGroup, UserSignalGroup} from '../../shared/types/sensor.types'

const canBeParsed = (value: unknown): value is RawUserSignalGroup => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'name' in value &&
    typeof value['name'] === 'string' &&
    'plantId' in value &&
    typeof value['plantId'] === 'string' &&
    'signals' in value &&
    Array.isArray(value['signals']) &&
    'combined' in value &&
    Array.isArray(value['combined'])
  )
}

export const useGetGroupsData = () => {
  const {data: userGroupsData, isPending} = useGetUserStorage({keyIdentifier: 'pm-user-groups'})

  const parsedGroups = useMemo(() => {
    if (!userGroupsData?.value) return []
    try {
      const responseData = JSON.parse(userGroupsData.value)
      if (!Array.isArray(responseData)) {
        throw new Error('Array expected, but got ' + typeof responseData)
      }
      const parsedGroups: UserSignalGroup[] = responseData
        .filter(canBeParsed)
        .map((parsableGroup) => {
          return {
            plantId: parsableGroup.plantId,
            name: parsableGroup.name,
            signals: parsableGroup.signals,
            combined: parsableGroup.combined,
            columns: parsableGroup.columns ? parsableGroup.columns : 1,
            quickSelection: parsableGroup.quickSelection ?? null,
            masterUpmId: parsableGroup.masterUpmId ?? null,
            chartsOrder: parsableGroup.chartsOrder ?? [],
            type: 'user'
          }
        })
      return parsedGroups
    } catch (e) {
      console.error('Failed to parse user groups data:', e)
      return []
    }
  }, [userGroupsData?.value])

  return {
    userGroups: parsedGroups,
    isPending
  }
}
